import { useEffect, useRef } from "react"
import { useAudioLevels } from '../../../hooks/useAudioData'

const AudioVisualizerCanvas = ( { audioTrack, type, draw, width = 50, height = 50 } ) => {
    const { levelsRef } = useAudioLevels( audioTrack, type )
    const canvasRef = useRef( null )


    useEffect( () => {
        const canvas = canvasRef.current
        if ( !canvas ) return
        const ctx = canvas.getContext( "2d" )
        const dpr = window.devicePixelRatio || 1

        // Set the actual pixel size of the canvas
        canvas.width = width * dpr
        canvas.height = height * dpr

        // Keep CSS size unchanged
        canvas.style.width = `${width}px`
        canvas.style.height = `${height}px`

        // Scale drawing so 1 unit = 1 CSS pixel
        ctx.scale( dpr, dpr )

        let raf
        const render = () => {
            ctx.clearRect( 0, 0, width, height )
            draw( ctx, levelsRef.current, width, height )
            raf = requestAnimationFrame( render )
        }

        render()
        return () => cancelAnimationFrame( raf )
    }, [levelsRef, draw, width, height] )

    return <canvas ref={canvasRef} />
}

export default AudioVisualizerCanvas
